import ReactConfetti from 'react-confetti';
import { useEffect, useState } from 'react';

export default function Confetti() {
    const [windowSize, setWindowSize] = useState<{ width: number; height: number }>({
        width: 0,
        height: 0,
    });

    const confettiSourceBottom = {
        x: 0, //horizontal starting location
        y: windowSize.height, //vertical starting location
        w: windowSize.width, //width of spray
        h: 0, //height of spray
    };

    useEffect((): void => {
        const handleWindowSize = () => {
            setWindowSize({ width: window.innerWidth, height: window.innerHeight });
        };

        handleWindowSize();

        window.onresize = () => handleWindowSize();
    }, []);
    return (
        <ReactConfetti
            colors={['#05EA00', '#EA0000', '#EAD300', '#005EEA', '#9F00EA', '#EAA900']}
            confettiSource={confettiSourceBottom}
            initialVelocityY={35}
            recycle={false}
            numberOfPieces={600}
            gravity={0.5}
            width={windowSize.width}
            height={document.body.scrollHeight}
        />
    );
}
